import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

/** 比べる位置（React Router の location のうち、見る欄だけ）。 */
export interface Place {
    readonly pathname: string;
    readonly search: string;
}

/**
 * 同じ画面の中でクエリだけが変わったか。<b>そのときは先頭へ戻さず、描いたものも作り直さない</b>
 * （検索・絞り込み・並べ替え。2026-10-10 に利用者が決めた。docs/01 §8）。
 * 同じ URL を開き直す（保存した後に戻る）のは当たらない——先頭の通知を見せる。
 */
export const onlyQueryChanged = (before: Place, after: Place): boolean =>
    before.pathname.toLowerCase() === after.pathname.toLowerCase() && before.search !== after.search;

/**
 * 画面を移ったら先頭へ戻す。<b>React Router は画面の中で移ってもスクロールの位置を変えない</b>ので、
 * 戻さないと前の画面の位置のまま次の画面が出る。クエリだけが変わったときは戻さない（<c>onlyQueryChanged</c>）。
 * 開いたときは何もしない（ブラウザに任せる）。
 */
export function ScrollOnMove(): null {
    const location = useLocation();
    const before = useRef(location);

    useEffect(() => {
        const last = before.current;
        before.current = location;
        if (last.key === location.key || onlyQueryChanged(last, location)) {
            return;
        }
        window.scrollTo(0, 0);
    }, [location]);

    return null;
}
